
const digest = '80441003984e17eaa4348a7f81ac50a438334b2ff8cedf51da77e12867da821a';
const classes = {"wrapper":"_wrapper_u02wi_1","addressContainer":"_addressContainer_u02wi_1","title":"_title_u02wi_14"};
const css = `._wrapper_u02wi_1 ._addressContainer_u02wi_1 {
  padding: 40px 50px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  border: 1px solid #e2e5ed;
  border-radius: 20px;
  width: fit-content;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
}
._wrapper_u02wi_1 ._addressContainer_u02wi_1 ._title_u02wi_14 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
}
._wrapper_u02wi_1 ._addressContainer_u02wi_1 span {
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  